import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from "pinia"
import { computed, getCurrentInstance } from "vue"

import ReverseTimer from "@/components/Common/ReverseTimer"
import DateRenderer from "@/components/TableRenderer/DateRenderer.vue"
import i18n from "@/i18n"
import { SyncDraftMeta, Synchronization, SyncTaskData } from "@/types/sync.type"

import { useSyncListStore } from "../store/useSyncListStore"
import { useSyncSettings } from "../syncList/useSyncSettings"

import DeleteSyncModal from "./DeleteSyncModal.vue"
import StopSyncModal from "./StopSyncModal.vue"

// Fix: Define dummy variables to hint types for Volar in legacy slot usage
// This is required because Volar cannot infer slot-scope types in usage of AntDV 1.x with script setup

export default /*#__PURE__*/_defineComponent({
  __name: 'SyncListTable',
  setup(__props) {

const record = {} as Synchronization & { task?: SyncTaskData; draftMeta?: SyncDraftMeta }
const nextSyncAt = 0 as number
const date = "" as string | null
const url = "" as string
const isActive = false as boolean
// End Fix

// Helper Types/Variables
const proxy = getCurrentInstance()?.proxy as any
// End Helper Types/Variables

// Store & Route
const syncListStore = useSyncListStore()

const { fetching, synchronizations, synchronizationsDraftsMetaFetching } =
  storeToRefs(syncListStore)
// End Store & Route

// Composables
const {
  isDeleteModalOpened,
  isStopModalOpened,
  startSyncRequestUuid,
  currentSyncUuid,
  handleOpenStopModal,
  handleOpenDeleteModal,
  handleCloseStopModal,
  handleCloseDeleteModal,
  handleStartSync
} = useSyncSettings()
// End Composables

// Computed
const tableData = computed<
  (Synchronization & { task?: SyncTaskData; draftMeta?: SyncDraftMeta })[]
>(() => {
  return synchronizations.value.map((sync) => {
    return {
      ...sync,
      task: syncListStore.synchronizationsTask[sync.uuid],
      draftMeta: syncListStore.synchronizationsDraftsMeta[sync.uuid]
    }
  })
})
const columns = computed(() => [
  {
    fixed: "left",
    title: "№",
    width: 30,
    customRender: (text: any, record: any, index: number) => {
      return {
        children: index + 1,
        props: {
          style: {
            textAlign: "center"
          }
        }
      }
    }
  },
  {
    fixed: "left",
    title: i18n.t("synchronization.last_synchronization_short"),
    dataIndex: "last_sync_ends_at",
    scopedSlots: { customRender: "last_sync_ends_at" },
    width: 100
  },
  {
    fixed: "left",
    title: i18n.t("synchronization.next_synchronization_time_short"),
    dataIndex: "next_sync_at",
    scopedSlots: { customRender: "nextSyncAtRenderer" },
    width: 110
  },
  {
    fixed: "left",
    title: i18n.t("synchronization.file_url"),
    dataIndex: "url",
    scopedSlots: { customRender: "urlRenderer" }
  },
  {
    dataIndex: "offers_all_in_file",
    scopedSlots: {
      title: "offersAllInFileTitleRenderer",
      customRender: "offersAllInFileRenderer"
    },
    align: "center",
    width: 130
  },
  {
    dataIndex: "offers_are_sold",
    scopedSlots: {
      title: "offersSellsTitleRenderer",
      customRender: "offersSellsRenderer"
    },
    align: "center",
    width: 120
  },
  {
    dataIndex: "offers_not_for_sale",
    scopedSlots: {
      title: "offersNotSellsTitleRenderer",
      customRender: "offersNotSellsRenderer"
    },
    align: "center",
    width: 130
  },
  {
    dataIndex: "offers_xml_errors",
    scopedSlots: {
      title: "offersXmlErrorsTitleRenderer",
      customRender: "offersXmlErrorsRenderer"
    },
    align: "center",
    width: 120
  },
  {
    dataIndex: "offers_need_action",
    scopedSlots: {
      title: "offersNeedActionTitleRenderer",
      customRender: "offersNeedActionRenderer"
    },
    align: "center",
    width: 120
  },
  {
    title: proxy.$t("common.status"),
    dataIndex: "is_active",
    scopedSlots: { customRender: "isActiveRenderer" },
    width: 120
  },
  {
    fixed: "right",
    dataIndex: "actions",
    scopedSlots: { customRender: "actionsRenderer" },
    width: 100
  }
])
// End Computed

// Methods
const updateSyncCallback = () => {
  syncListStore.getSynchronizations()
}
// End Methods

return { __sfc: true,record, nextSyncAt, date, url, isActive, proxy, syncListStore, fetching, synchronizations, synchronizationsDraftsMetaFetching, isDeleteModalOpened, isStopModalOpened, startSyncRequestUuid, currentSyncUuid, handleOpenStopModal, handleOpenDeleteModal, handleCloseStopModal, handleCloseDeleteModal, handleStartSync, tableData, columns, updateSyncCallback, ReverseTimer, DateRenderer, DeleteSyncModal, StopSyncModal }
}

})